import React, { useEffect, useState } from 'react';
import { inmobiliariasService } from '../services/api';

const FORM_VACIO = { nombre: '', telefono: '', email: '', contacto: '', notas: '' };

export default function Inmobiliarias() {
  const [inmobiliarias, setInmobiliarias] = useState([]);
  const [modal, setModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState(FORM_VACIO);
  const [vistaLista, setVistaLista] = useState(false);

  const cargar = () => inmobiliariasService.getAll().then(r => setInmobiliarias(r.data));
  useEffect(() => { cargar(); }, []);

  const abrirNuevo = () => { setEditando(null); setForm(FORM_VACIO); setModal(true); };
  const abrirEditar = (inm) => {
    setEditando(inm.id);
    setForm({ nombre: inm.nombre || '', telefono: inm.telefono || '', email: inm.email || '', contacto: inm.contacto || '', notas: inm.notas || '' });
    setModal(true);
  };
  const cerrar = () => { setModal(false); setEditando(null); setForm(FORM_VACIO); };
  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    if (editando) await inmobiliariasService.update(editando, form);
    else await inmobiliariasService.create(form);
    cerrar();
    cargar();
  };

  const handleEliminar = async (inm) => {
    if (parseInt(inm.contratos_activos) > 0) {
      alert(`No se puede eliminar "${inm.nombre}" porque tiene ${inm.contratos_activos} contrato(s) activo(s).`);
      return;
    }
    if (window.confirm(`¿Eliminar "${inm.nombre}"?`)) {
      await inmobiliariasService.delete(inm.id);
      cargar();
    }
  };

  return (
    <div>
      <div className="page-header">
        <h1>Inmobiliarias</h1>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <div className="view-toggle">
            <button className={!vistaLista ? 'active' : ''} onClick={() => setVistaLista(false)} title="Vista tarjetas">▦ Tarjetas</button>
            <button className={vistaLista ? 'active' : ''} onClick={() => setVistaLista(true)} title="Vista lista">☰ Lista</button>
          </div>
          <button className="btn btn-primary" onClick={abrirNuevo}>+ Nueva inmobiliaria</button>
        </div>
      </div>

      {inmobiliarias.length === 0 ? (
        <div className="empty-state">
          <h3>No hay inmobiliarias cargadas</h3>
          <p>Agregá las inmobiliarias con las que trabajás</p>
        </div>
      ) : vistaLista ? (
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Contacto</th>
                <th>Teléfono</th>
                <th>Email</th>
                <th>Contratos activos</th>
                <th>Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {inmobiliarias.map(inm => (
                <tr key={inm.id}>
                  <td><strong>{inm.nombre}</strong></td>
                  <td>{inm.contacto || '-'}</td>
                  <td>{inm.telefono ? <a href={`tel:${inm.telefono}`} style={{ color: '#555', textDecoration: 'none' }}>{inm.telefono}</a> : '-'}</td>
                  <td>{inm.email ? <a href={`mailto:${inm.email}`} style={{ color: '#4f8ef7', textDecoration: 'none' }}>{inm.email}</a> : '-'}</td>
                  <td>
                    <span style={{ fontSize: '0.75rem', padding: '3px 10px', borderRadius: 20, background: parseInt(inm.contratos_activos) > 0 ? '#eafaf1' : '#f0f0f0', color: parseInt(inm.contratos_activos) > 0 ? '#27ae60' : '#aaa', fontWeight: 600 }}>
                      {inm.contratos_activos}
                    </span>
                  </td>
                  <td>{inm.total_contratos}</td>
                  <td>
                    <div style={{ display: 'flex', gap: 4 }}>
                      <button className="btn btn-secondary" style={{ padding: '5px 10px', fontSize: '0.78rem' }} onClick={() => abrirEditar(inm)}>✏️</button>
                      <button className="btn" style={{ padding: '5px 10px', fontSize: '0.78rem', background: '#fdecea', color: '#e74c3c' }} onClick={() => handleEliminar(inm)}>🗑</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="cards-grid">
          {inmobiliarias.map(inm => (
            <div key={inm.id} className="card" style={{ borderTop: '4px solid #4f8ef7' }}>
              <div className="card-header">
                <h3>🏢 {inm.nombre}</h3>
                <span style={{ fontSize: '0.75rem', padding: '3px 10px', borderRadius: 20, background: parseInt(inm.contratos_activos) > 0 ? '#eafaf1' : '#f0f0f0', color: parseInt(inm.contratos_activos) > 0 ? '#27ae60' : '#aaa', fontWeight: 600 }}>
                  {inm.contratos_activos} activo{inm.contratos_activos !== '1' ? 's' : ''}
                </span>
              </div>

              {inm.contacto && <p style={{ fontSize: '0.85rem', color: '#555', marginBottom: 4 }}>👤 {inm.contacto}</p>}
              {inm.telefono && (
                <p style={{ fontSize: '0.85rem', color: '#555', marginBottom: 4 }}>
                  📱 <a href={`tel:${inm.telefono}`} style={{ color: '#555', textDecoration: 'none' }}>{inm.telefono}</a>
                </p>
              )}
              {inm.email && (
                <p style={{ fontSize: '0.85rem', color: '#555', marginBottom: 4 }}>
                  📧 <a href={`mailto:${inm.email}`} style={{ color: '#4f8ef7', textDecoration: 'none' }}>{inm.email}</a>
                </p>
              )}
              {inm.notas && <p style={{ fontSize: '0.8rem', color: '#aaa', marginTop: 6 }}>📝 {inm.notas}</p>}

              <div style={{ fontSize: '0.78rem', color: '#aaa', marginTop: 8 }}>
                {inm.total_contratos} contrato{inm.total_contratos !== '1' ? 's' : ''} en total
              </div>

              <div style={{ display: 'flex', gap: 8, marginTop: 14 }}>
                <button className="btn btn-secondary" style={{ flex: 1, fontSize: '0.82rem', padding: '7px 0' }} onClick={() => abrirEditar(inm)}>✏️ Editar</button>
                <button className="btn" style={{ padding: '7px 12px', fontSize: '0.82rem', background: '#fdecea', color: '#e74c3c' }} onClick={() => handleEliminar(inm)}>🗑</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {modal && (
        <div className="modal-overlay" onClick={cerrar}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>{editando ? 'Editar inmobiliaria' : 'Nueva inmobiliaria'}</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group full">
                  <label>Nombre *</label>
                  <input name="nombre" value={form.nombre} onChange={handle} required placeholder="Ej: HR Propiedades" />
                </div>
                <div className="form-group">
                  <label>Contacto (persona)</label>
                  <input name="contacto" value={form.contacto} onChange={handle} placeholder="Nombre del agente" />
                </div>
                <div className="form-group">
                  <label>Teléfono</label>
                  <input name="telefono" value={form.telefono} onChange={handle} placeholder="Ej: 099 123 456" />
                </div>
                <div className="form-group full">
                  <label>Email</label>
                  <input name="email" type="email" value={form.email} onChange={handle} placeholder="contacto@inmobiliaria.com" />
                </div>
                <div className="form-group full">
                  <label>Notas</label>
                  <textarea name="notas" value={form.notas} onChange={handle} rows={3} />
                </div>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={cerrar}>Cancelar</button>
                <button type="submit" className="btn btn-primary">{editando ? 'Guardar cambios' : 'Guardar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
